import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/**
 * Null when the environment is not configured, so the app can render a clear
 * setup message instead of throwing on first paint.
 *
 * These point at the household project, which is not the business one. Crossing
 * the two is the mistake that looks like it works: the app comes up, sign-in
 * succeeds against the wrong auth server, and the first thing anybody notices is
 * a record that is not theirs.
 */
export const supabase: SupabaseClient | null =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      })
    : null

export const supabaseConfigured = supabase !== null
